import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Heart, ArrowRight } from 'lucide-react';
import './AccountDeleted.css';

/**
 * AccountDeleted - Friendly confirmation page shown after account deletion
 * Offers option to recover the account
 */
export const AccountDeleted = () => {
  const navigate = useNavigate();

  const handleRecoverAccount = () => {
    navigate('/member/recover');
  };

  const handleBackToSite = () => {
    navigate('/');
  };

  return (
    <div className="account-deleted-page">
      <div className="account-deleted-container">
        <div className="account-deleted-icon">
          <CheckCircle size={64} />
        </div>
        
        <h1>Your account has been deleted</h1>
        
        <p className="account-deleted-message">
          We've removed your access to the Golf Nuts Clubhouse.
        </p>
        
        <div className="miss-you-card">
          <Heart size={24} className="heart-icon" />
          <p>We'll miss you! Thanks for being part of our community.</p>
        </div>
        
        <p className="recovery-info">
          Changed your mind? You can recover your account anytime.
        </p>
        
        <div className="account-deleted-actions">
          <button className="btn-recover" onClick={handleRecoverAccount}>
            Recover My Account <ArrowRight size={18} />
          </button>
          <button className="btn-home" onClick={handleBackToSite}>
            Back to Golf Nuts
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountDeleted;
